"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.payerConfigRequestValidation = exports.emptyConfigSchema = exports.btgSheetConfigSchema = exports.itauSheetConfigSchema = exports.cnabConfigSchema = exports.apiInterConfigSchema = exports.kaminoConfigSchema = exports.PaymentOptionTypes = exports.KaminoLabelsName = void 0;
const zod_1 = require("zod");
var KaminoLabelsName;
(function (KaminoLabelsName) {
    KaminoLabelsName["CATEGORY"] = "category";
    KaminoLabelsName["COST_CENTER"] = "cost_center";
})(KaminoLabelsName = exports.KaminoLabelsName || (exports.KaminoLabelsName = {}));
var PaymentOptionTypes;
(function (PaymentOptionTypes) {
    PaymentOptionTypes["API_INTER"] = "api_inter";
    PaymentOptionTypes["CNAB"] = "cnab";
    PaymentOptionTypes["ITAU_SHEET"] = "planilha_itau";
    PaymentOptionTypes["BTG_SHEET"] = "planilha_btg";
    PaymentOptionTypes["API_KAMINO"] = "api_kamino";
    PaymentOptionTypes["EMPTY"] = "empty";
})(PaymentOptionTypes = exports.PaymentOptionTypes || (exports.PaymentOptionTypes = {}));
exports.kaminoConfigSchema = zod_1.z.object({
    type: zod_1.z.literal(PaymentOptionTypes.API_KAMINO),
    labels: zod_1.z.array(zod_1.z.object({ name: zod_1.z.nativeEnum(KaminoLabelsName), value: zod_1.z.string() })).optional(),
    payer_name: zod_1.z.string({ required_error: `O campo 'Nome do pagador' é obrigatório` }),
    payer_cnpj: zod_1.z.string({ required_error: `O campo 'CNPJ' é obrigatório` }),
    credential: zod_1.z.string({ required_error: `O campo 'Credencial' é obrigatório` }),
});
exports.apiInterConfigSchema = zod_1.z.object({
    type: zod_1.z.literal(PaymentOptionTypes.API_INTER),
    certificatePem: zod_1.z.string({ required_error: `O campo 'Certificado Público' é obrigatório` }),
    clientId: zod_1.z.string({ required_error: `O campo 'Identificador do Cliente' é obrigatório` }),
    clientSecret: zod_1.z.string({ required_error: `O campo 'Palavra-passe do Cliente' é obrigatório` }),
    privateKeyPem: zod_1.z.string({ required_error: `O campo 'Chave Privada' é obrigatório` }),
});
exports.cnabConfigSchema = zod_1.z.object({
    type: zod_1.z.literal(PaymentOptionTypes.CNAB),
    payment_date: zod_1.z.string().optional(),
    payer_name: zod_1.z.string({ required_error: `O campo 'Nome do pagador' é obrigatório` }),
    payer_cnpj: zod_1.z.string({ required_error: `O campo 'CNPJ' é obrigatório` }),
    payer_address: zod_1.z.object({
        street: zod_1.z.string({ required_error: `O campo 'Rua' é obrigatório` }),
        number: zod_1.z.string({ required_error: `O campo 'Número' é obrigatório` }),
        complement: zod_1.z.string().optional(),
        city: zod_1.z.string({ required_error: `O campo 'Cidade' é obrigatório` }),
        zip_code: zod_1.z.string({ required_error: `O campo 'CEP' é obrigatório` }),
        state: zod_1.z.string({ required_error: `O campo 'Estado' é obrigatório` }),
    }),
    payer_account: zod_1.z.object({
        bank_code: zod_1.z.literal('341').default('341').optional(),
        branch: zod_1.z.string({ required_error: `O campo 'Agência' é obrigatório` }),
        account: zod_1.z.string({ required_error: `O campo 'Conta' é obrigatório` }),
        account_digit: zod_1.z.string({ required_error: `O campo 'Dígito da conta' é obrigatório` }),
    }),
});
exports.itauSheetConfigSchema = zod_1.z.object({
    type: zod_1.z.literal(PaymentOptionTypes.ITAU_SHEET),
    payment_type: zod_1.z.number().optional(),
});
exports.btgSheetConfigSchema = zod_1.z.object({
    type: zod_1.z.literal(PaymentOptionTypes.BTG_SHEET),
    payment_type: zod_1.z.number().optional(),
});
exports.emptyConfigSchema = zod_1.z.object({
    type: zod_1.z.literal(PaymentOptionTypes.EMPTY),
});
exports.payerConfigRequestValidation = zod_1.z.discriminatedUnion('type', [
    exports.apiInterConfigSchema,
    exports.kaminoConfigSchema,
    exports.cnabConfigSchema,
    exports.itauSheetConfigSchema,
    exports.btgSheetConfigSchema,
    exports.emptyConfigSchema,
]);
